export const CREATE = {
  name: 'CREATE'
};

export const REQUEST_REVIEW = {
  name: 'REQUEST_REVIEW'
};

export const SEND_TO_APPROVER = {
  name: 'SEND_TO_APPROVER'
};

export const APPROVE_AND_SEND_TO_CUSTOMER = {
  name: 'APPROVE_AND_SEND_TO_CUSTOMER'
};

export const APPROVE = {
  name: 'APPROVE'
};

export const ACCEPT = {
  name: 'ACCEPT'
};

export const DELETE = {
  name: 'DELETE'
};
